import React, { useEffect, useState } from 'react';
import { ShoppingBag } from 'lucide-react';
import { getProducts } from '../api/api';
import ProductCard from './ProductCard';

let _all = null;

export const ShopTheLook = ({ slugs = [] }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (slugs.length === 0) return;
    let alive = true;
    (_all ? Promise.resolve(_all) : getProducts().then((p) => (_all = p)))
      .then((all) => {
        if (!alive) return;
        const bySlug = Object.fromEntries(all.map((p) => [p.slug, p]));
        setProducts(slugs.map((s) => bySlug[s]).filter(Boolean));
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [slugs]);

  if (products.length === 0) return null;

  return (
    <section className="mt-12" data-testid="pr-shop-the-look">
      <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-600 mb-2">
        <ShoppingBag size={14} /> Shop this look
      </span>
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">Featured in this article</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </section>
  );
};

export default ShopTheLook;
